export default __webpack_public_path__ + "static/media/ehealth.e3296943.png";